/* 🤖 this file was generated by svg-to-ts */
export const matIconCrop54: {
  name: 'crop-5-4';
  data: string;
} = {
  name: 'crop-5-4',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"/></svg>`
};
